import { Paper, Typography, Box } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import Loading from "../ui/Loading";

ChartJS.register(ArcElement, Tooltip, Legend);

const CallsByStatusCard = ({ data, isLoading, error }) => {
  if (isLoading) return <Loading />;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!data || !data.statusCounts)
    return <Typography>No data available</Typography>;

  const statusCounts = data.statusCounts;
  const labels = Object.keys(statusCounts);
  const values = Object.values(statusCounts);

  const chartData = {
    labels: labels.map(
      (label) => label.charAt(0).toUpperCase() + label.slice(1)
    ),
    datasets: [
      {
        data: values,
        backgroundColor: [
          "rgba(75, 192, 192, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(255, 99, 132, 0.6)",
        ],
        borderColor: [
          "rgba(75, 192, 192, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(255, 99, 132, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <Paper sx={{ p: 2, height: "100%" }}>
      <Typography
        variant="h6"
        gutterBottom
      >
        Calls by Status
      </Typography>
      <Box
        sx={{
          height: 280,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Doughnut
          data={chartData}
          options={options}
        />
      </Box>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 1, textAlign: "center" }}
      >
        Total: {data.total || 0} calls
      </Typography>
    </Paper>
  );
};

export default CallsByStatusCard;
